import { getEventDesktop } from "app/api/eventsApi";
import * as FavouriteAPI from "app/api/favouritesApi";
import CountDownDuration from "app/components/CountDownDuration/CountDownDuration";
import DangerZoneTextOnly from "app/components/DangerZoneTextOnly/DangerZoneTextOnly";
import { GolfPhase } from "app/components/GolfPhase/GolfPhase";
import { IconCornerDesktop } from "app/components/Icon/Icon";
import StartTimeScore from "app/components/StartTimeScore/StartTimeScore";
import TimeSectionTimePhase from "app/components/TimeSectionLivePhase/TimeSectionTimePhase";
import { EventHelper } from "app/helpers/eventHelper";
import type { EventType } from "app/types/eventType";
import { DangerZoneStates, SportsNameType } from "app/utils/const";
import React, { Component } from "react";
import { connect } from "react-redux";
import ModalEventIcons from "./components/ModalEventIcons/ModalEventIcons";
import "./EventName.scss";
import { OnClickGraphHelper } from "./helpers/OnClickGraphHelper/OnClickGraphHelper";

type Props = {
  event: Record<string, any>;
  setPositionMatrixModalEvent: (...args: Array<any>) => any;
  setPositionMatrixModalItem: (...args: Array<any>) => any;
  openPositionMatrixModal: (...args: Array<any>) => any;
  toggleMarketGraph: (...args: Array<any>) => any;
  favouritesOnly: boolean;
  addFavouriteToList: (...args: Array<any>) => any;
  removeFromFavouritesList: (...args: Array<any>) => any;
  setEventFavourite: (...args: Array<any>) => any;
  fetchEventData: (...args: Array<any>) => any;
};
type State = {
  isFavourite: boolean;
}; //

class EventName extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isFavourite: this.props.event.favourite,
    };
  }

  onClickPositionMatrix = (event: any) => {
    this.props.setPositionMatrixModalEvent(event);
    this.props.setPositionMatrixModalItem(event.id);
    this.props.openPositionMatrixModal();
  };
  onClickGraph = () => {
    OnClickGraphHelper.onClickGraph(this.props.event);
  };
  // / toggling add/remove favourites by clicking favourites button
  toggleAddRemoveToFavorites = (eventId: number) => {
    const { favouritesOnly } = this.props;

    if (this.state.isFavourite === false) {
      this.props.addFavouriteToList(eventId);
      this.updateFavourite(eventId, favouritesOnly);
    } else {
      this.props.removeFromFavouritesList(eventId);
      this.updateFavourite(eventId, favouritesOnly);
    }
  };
  // update events with latest favourite status
  updateFavourite = (eventId: number, favouritesOnly: boolean) => {
    this.setState({
      isFavourite: !this.state.isFavourite,
    });
    // since web socket update not avaiable use AJAX call
    getEventDesktop(eventId, true)
      .then(eventData => {
        this.props.setEventFavourite(eventData, favouritesOnly);
        // get latest favourites from API
        FavouriteAPI.getFavouriteList();
        this.props.fetchEventData();
      })
      .catch(error => {
        throw error;
      });
  };
  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.event.favourite !== this.props.event.favourite) {
      this.setState({
        isFavourite: this.props.event.favourite,
      });
    }
  };

  render() {
    const { event } = this.props;
    const eventIncidents = event["eventIncidents"];
    const { isHome, isAway, possibleVar, incidentType, dangerZoneState } =
      EventHelper.formatIncidentText(eventIncidents && eventIncidents[0]);
    const showDangerText =
      eventIncidents != null &&
      (incidentType != null ||
        possibleVar ||
        dangerZoneState !== DangerZoneStates.SAFE ||
        dangerZoneState !== DangerZoneStates.MISSED_INCIDENT);
    const showLiveStats =
      event.sportType === SportsNameType.SOCCER &&
      EventHelper.isEventLive(event) &&
      !EventHelper.isEventLiveWithNoScore(event);
    const isEventLive = EventHelper.isEventLive(event);
    const isEventPhaseLive = EventHelper.isEventPhaseOfTypeLive(event);
    const isLiveCricket = EventHelper.isEventLiveCricket(event);
    const isGolfEvent = this.props.event.sportType === "GOLF";
    const yellowCards = {
      home: 0,
      away: 0,
    };
    const redCards = {
      home: 0,
      away: 0,
    };
    const corners = {
      home: 0,
      away: 0,
    };
    let eventStat = null;

    if (eventIncidents != null) {
      eventStat = eventIncidents[0];

      if (eventStat["eventPhase"].includes("EXTRA_TIME")) {
        eventStat["currentPeriodScoreDetails"].forEach(currentScore => {
          switch (currentScore.type) {
            case "HOME_YELLOW_CARD":
              yellowCards.home += currentScore.score;
              break;

            case "AWAY_YELLOW_CARD":
              yellowCards.away += currentScore.score;
              break;

            case "HOME_RED_CARD":
              redCards.home += currentScore.score;
              break;

            case "AWAY_RED_CARD":
              redCards.away += currentScore.score;
              break;

            case "HOME_CORNER":
              corners.home += currentScore.score;
              break;

            case "AWAY_CORNER":
              corners.away += currentScore.score;
              break;

            default:
              return null;
          }
        });
      } else {
        eventStat["scoreDetails"].forEach(currentScore => {
          switch (currentScore.type) {
            case "HOME_YELLOW_CARD":
              yellowCards.home += currentScore.score;
              break;

            case "AWAY_YELLOW_CARD":
              yellowCards.away += currentScore.score;
              break;

            case "HOME_RED_CARD":
              redCards.home += currentScore.score;
              break;

            case "AWAY_RED_CARD":
              redCards.away += currentScore.score;
              break;

            case "HOME_CORNER":
              corners.home += currentScore.score;
              break;

            case "AWAY_CORNER":
              corners.away += currentScore.score;
              break;

            default:
              return null;
          }
        });
      }
    }

    // Euro unsummarised view should always show the widget for live cricket.
    // If widget not available and the event is live cricket, show 'live' text
    return (
      <div className="unsummarized-markets-modal__event-name">
        <div className="unsummarized-markets-modal__event-name__lhs">
          {isEventLive && (isEventPhaseLive || isLiveCricket || isGolfEvent) ? (
            <div className="time">
              <TimeSectionTimePhase />
            </div>
          ) : (
            <div className="time">
              <span className="time__top">
                <StartTimeScore eventData={event} />
              </span>
              <span className="time__bottom">
                <CountDownDuration eventData={event} />
              </span>
            </div>
          )}
          <div>
            <div className="unsummarized-markets-modal__stats__icons-wrapper">
              {showLiveStats && (
                <div className="unsummarized-markets-modal__stats__icons">
                  <div className="unsummarized-markets-modal__stats__icons--yellow-cards" />
                  <div className="unsummarized-markets-modal__stats__icons--red-cards" />
                  <div className="unsummarized-markets-modal__stats__icons--corners-icon">
                    <IconCornerDesktop />
                  </div>
                </div>
              )}
            </div>
            {event.sportType === SportsNameType.GOLF ? (
              <>
                <div className="event-name__name">{event.name}</div>
                {isEventLive ? <GolfPhase eventData={event} /> : ""}
              </>
            ) : (
              <React.Fragment>
                <div className="row">
                  <div>
                    <span
                      className={`event-name ${
                        showDangerText && isHome ? "highlight" : ""
                      }`}
                    >
                      {event.participant1}
                    </span>
                    <div className="unsummarized-markets-modal__stats__rhs">
                      {showDangerText && isHome && (
                        <div className="is-home">
                          <DangerZoneTextOnly
                            eventIncident={eventIncidents[0]}
                            className={event.isActive ? "active" : ""}
                            incidentType={incidentType}
                            dangerZoneState={dangerZoneState}
                            possibleVar={possibleVar}
                            isAway={isAway}
                            isHome={isHome}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {showLiveStats && (
                    <div className="unsummarized-markets-modal__stats">
                      <div className="unsummarized-markets-modal__stats__lhs">
                        <div className="unsummarized-markets-modal__stats__totals">
                          <span>{yellowCards.home}</span>
                          <span>{redCards.home}</span>
                          <span>{corners.home}</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div>
                    <span
                      className={`event-name ${
                        showDangerText && isAway ? "highlight" : ""
                      }`}
                    >
                      {event.participant2}
                    </span>
                    <div className="unsummarized-markets-modal__stats__rhs">
                      {showDangerText && isAway && (
                        <div className="is-away">
                          <DangerZoneTextOnly
                            eventIncident={eventIncidents[0]}
                            className={event.isActive ? "active" : ""}
                            incidentType={incidentType}
                            dangerZoneState={dangerZoneState}
                            possibleVar={possibleVar}
                            isAway={isAway}
                            isHome={isHome}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {showLiveStats && (
                    <div className="unsummarized-markets-modal__stats">
                      <div className="unsummarized-markets-modal__stats__lhs">
                        <div className="unsummarized-markets-modal__stats__totals">
                          <span>{yellowCards.away}</span>
                          <span>{redCards.away}</span>
                          <span>{corners.away}</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
        <div className="event-icons-options">
          <ModalEventIcons
            event={event}
            onClickPositionMatrix={this.onClickPositionMatrix}
            toggleAddRemoveToFavorites={this.toggleAddRemoveToFavorites}
            onClickGraph={this.onClickGraph}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  favouritesOnly: state.competitionListModel.favouritesOnly,
});

const mapDispatchToProps = dispatch => ({
  toggleMarketGraph: (eventData, runner, market) => {
    dispatch.marketDataGraphModel.openMarketGraphModal(
      eventData,
      runner,
      market
    );
  },
  setPositionMatrixModalEvent: event => {
    dispatch.positionMatrixListModel.setPositionMatrixModalEvent(event);
  },
  setPositionMatrixModalItem: (eventId: number) => {
    dispatch.positionMatrixListModel.setPositionMatrixModalItem({
      eventId: eventId,
    });
  },
  resetPositionMatrix: () => {
    dispatch.positionMatrixListModel.closePositionMatrixModal();
  },
  openPositionMatrixModal: () => {
    dispatch.positionMatrixListModel.openPositionMatrixModal();
  },
  addFavouriteToList: (eventId, callback) =>
    dispatch.favouritesListModel.addFavouriteToList({
      eventId,
      callback,
    }),
  removeFromFavouritesList: (eventId, callback) =>
    dispatch.favouritesListModel.removeFromFavouriteToList({
      eventId,
      callback,
    }),
  setEventFavourite: (event: EventType, favouritesOnly: boolean) =>
    dispatch.competitionListModel.updateEventFavouriteInCompetitionInList(
      event,
      favouritesOnly
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventName) as any;
